import { sortBy as rSortBy, prop as rProp, propEq } from 'ramda';
import React from 'react';
import Zousan from 'zousan';

import { StateObjMultiple } from '@utils/stateObj.ts';

import { widgetEnum } from '../../../../utils/constants.ts';
import { focusElement } from '../../../utils/focusUtils.ts';
import MapLevelSelectorOnline from './MapLevelSelectorOnlineView.tsx';
import MapLevelSelectorViewMobile from './MapLevelSelectorViewMobile.tsx';
import { ResultsOnOtherFloorsBanner } from './ResultsOnOtherFloorsBanner.tsx';

function create(app) {
  const init = () => {
    app.bus.send('venueData/loadBuildingSelectorData');
  };
  const widgetState = new StateObjMultiple({
    buildings: [],
    searchResults: [],
    viewport: {},
    isMenuOpen: false,
  });
  let selectorDataLoaded = new Zousan();

  app.bus.send('layers/register', {
    id: 'ResultsOnOtherLevelsBanner',
    widget: () => <ResultsOnOtherFloorsBanner widgetState={widgetState} bus={app.bus} />,
    isOverlay: true,
    layoutId: 'map',
    show: true,
    widgetType: widgetEnum.Mobile,
    shouldShow: currentlyShowing => currentlyShowing.includes('SearchResultsHeader'),
  });

  app.bus.send('layers/register', {
    id: 'mapLevelSelectorOnline',
    widget: () => (
      <MapLevelSelectorOnline bus={app.bus} widgetState={widgetState} T={app.gt()} isMobile={app.env.isMobile()} />
    ),
    isOverlay: true,
    layoutId: 'mapControls',
    shouldShow: currentlyShowing => {
      if (app.config.uiHide && app.config.uiHide.levelSelector) {
        return false;
      } // allows uiHide configuration parameter to hide this control
      if (!app.env.isMobile()) {
        return true;
      }
      if (currentlyShowing.includes('SearchResultsBody') && currentlyShowing.includes('SearchResultsHeader')) {
        return true;
      }
      // Commenting out the following 2 lines for now, as the whole speed dial is hidden when these widgets are present anyway
      // const widgetsToCheck = ['SearchResultsHeader', 'DirectionsSearchControls', 'DirectionsResultControls', 'DirectionsResultMobile', 'poiViewMobile', 'SearchResultsCategoryList']
      // return !widgetsToCheck.some(widget => currentlyShowing.includes(widget))
      return true;
    },
    order: 30,
  });

  app.bus.send('layers/register', {
    id: 'mapLevelSelectorViewMobile',
    widget: () => <MapLevelSelectorViewMobile widgetState={widgetState} bus={app.bus} T={app.gt()} />,
    layoutId: 'mobileLevelSelector',
    isOverlay: true,
    show: true,
    widgetType: widgetEnum.Mobile,
  });

  const notifyState = () => {
    // const { selectedBuilding, selectedLevel } = widgetState.getState()
    // app.bus.send('deepLinking/notifyState', {
    //   id: 'mapLevelSelectorOnline',
    //   selectedBuildingId: selectedBuilding ? selectedBuilding.id : null,
    //   selectedLevelId: selectedLevel ? selectedLevel.id : null
    // })
  };

  app.bus.on('venueData/buildingSelectorDataLoaded', ({ buildings, structureOrder, selectorOrder }) => {
    const orderBy = selectorOrder || structureOrder || [];
    const buildingsWithOrder = buildings.map((building, index) => ({
      ...building,
      order: (orderBy.length > 0 ? orderBy.indexOf(building.id) : index) + 1,
    }));
    const orderedBuildings = rSortBy(rProp('order'), buildingsWithOrder);
    const selectorData = { buildings: orderedBuildings };
    widgetState.update(selectorData);
    selectorDataLoaded.resolve(selectorData);
    notifyState();
  });

  const changeSelection = (structure, floor) => {
    const { buildings } = widgetState.getState();
    // do not show building which is not listed in level selector
    if (structure && buildings.find(propEq(structure.id, 'id'))) {
      widgetState.update({ selectedBuilding: structure, selectedLevel: floor });
    } else {
      widgetState.update({ selectedBuilding: null, selectedLevel: null });
    }
    notifyState();
  };

  app.bus.on('map/floorChanged', ({ structure, floor }) => changeSelection(structure, floor));

  app.bus.on('map/getCurrentStructure', async () => {
    const { selectedBuilding, selectedLevel } = widgetState.getState();
    return { building: selectedBuilding, level: selectedLevel };
  });

  app.bus.on('venueData/loadNewVenue', () => {
    selectorDataLoaded = new Zousan();
    init();
  });

  app.bus.on('searchResults/showPOIs', ({ pois = [] }) => widgetState.update({ searchResults: pois }));

  app.bus.on('app/reset', () => app.bus.send('mapLevelSelectorOnline/closeLevelSelector'));

  const clearSearchResults = () => widgetState.update({ searchResults: [] });

  app.bus.on('headerOnline/show', clearSearchResults);
  app.bus.on('navigation/show', clearSearchResults);

  app.bus.on('mapLevelSelectorOnline/openLevelSelector', () => {
    widgetState.update({ isMenuOpen: true });
    if (app.env.isMobile()) {
      app.bus.send('mapPanControls/panControlsOpen', { shouldOpen: false });
    }
  });

  app.bus.on('mapLevelSelectorOnline/closeLevelSelector', () => {
    widgetState.update({ isMenuOpen: false });
    if (app.env.isMobile()) {
      focusElement('[data-testid="MapLevelSelectorMobileButton"]');
    }
  });

  const closeMobileSelectorOnMap = () => {
    const { isMenuOpen } = widgetState.getState();
    if (isMenuOpen && app.env.isMobile()) {
      app.bus.send('mapLevelSelectorOnline/closeLevelSelector');
    }
  };

  app.bus.on('map/userMoveStart', closeMobileSelectorOnMap);
  app.bus.on('map/click', closeMobileSelectorOnMap);
  app.bus.on('env/resize', closeMobileSelectorOnMap);

  // Close level selector when pan controls open
  app.bus.on('mapPanControls/panControlsOpen', ({ shouldOpen }) => {
    const { isMenuOpen } = widgetState.getState();
    // If user is opening pan controls, and level selector is open, close it
    if (shouldOpen && isMenuOpen) {
      app.bus.send('mapLevelSelectorOnline/closeLevelSelector');
    }
  });

  return {
    init,
  };
}

export { create };
